<style scoped>
.el-button--info {
    box-shadow: 0 1px 7px rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(0, 0, 0, 0.04) !important;
    padding: 10px;
    background-color: white;
    color: black;
}

.el-button--info:hover {
    box-shadow: 0 1px 40px rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(0, 0, 0, 0.04) !important;
    padding: 10px;
    background-color: white;
    color: black;
}

.content-wrapper .content {
    padding-top: 95px;
}

.el-select {
    display: block;
}

.recentlyClosed {
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.opened {
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.box-body {
    padding: 15px !important;
}

.heading-cart {
    padding: unset !important;
    border: unset !important;
    position: relative;
    margin: 0 0 15px 0 !important;
}
.heading-cart a {
    position: relative;
    margin-right: 10px;
}

.box-title {
    display: inline-block;
    font-size: 12px;
    margin: 0;
    line-height: 1;
}

h5 {
    line-height: 2;
}

.bidder-config-layout {
    border: 1px solid #00000040;
    background-color: #f5f7fa;
    margin: 10px !important;
    padding: 5px;
    width: 90%;
}
</style>
<template>
    <div class="content-wrapper">
        <section class="content">
            <div class="box" v-loading="Object.values(loading).some(x => x===true)">
                <div class="box-header with-border">
                    <div class="heading-cart">
                        <h3 class="box-title">HB Unit Bidder Config</h3>

                        <a
                            href="#"
                            style="background: #5cb85c"
                            @click="updatedHBBidder"
                            >Save</a
                        >
                        <a
                            href="#"
                            style="background: #5cb85c"
                            @click="selectAllBidders"
                            >Select all bidders</a
                        >
                        <a
                            href="#"
                            style="background: #c9302c"
                            @click="unSelectAllBidders"
                            >Un-Select all bidders</a
                        >
                        <el-row style="padding: 20px 20px 0px">
                            <el-col
                                v-for="(bidder, idx) in allBidders"
                                :span="5"
                                :key="idx"
                            >
                                <el-checkbox
                                    @change="handleSelectAll(bidder)"
                                    ref="bidderAllCheck"
                                    :checked="bidder.all"
                                    :value="bidder.all"
                                    :key="bidder.id"
                                    >Check all {{ bidder.name }}</el-checkbox
                                >
                                <div style="margin: 15px 0"></div>
                            </el-col>
                        </el-row>
                    </div>
                </div>
                <div class="box-body">
                    <div>
                        <el-input
                            style="
                                display: inline-block;
                                width: 80%;
                                margin: 0 0 10px 10px;
                            "
                            data-vv-delay="1000"
                            name="searchString"
                            type="text"
                            placeholder="search HB Unit by HB Unit tag (type and enter)"
                            v-model="searchString"
                            @keyup.enter.native="filterHBunitBidder()"
                        ></el-input>
                        <el-tooltip content="clearSearch" placement="top">
                            <el-button
                                type="danger"
                                icon="el-icon-close"
                                @click="clearSearch()"
                                style="display: inline-block"
                            >
                                <!-- <i class="el-icon-close"></i> -->
                            </el-button>
                        </el-tooltip>
                    </div>
                    <div class="col-md-4" style="padding-left: 10px">
                        <el-input
                            style="display: inline-block"
                            data-vv-delay="1000"
                            name="selectedNetworkCode"
                            type="text"
                            placeholder="Search Parent Network Code"
                            v-model="selectedNetworkCode"
                            @keyup.enter.native="filterHBunitBidder()"
                        ></el-input>
                    </div>

                    <div class="col-md-4">
                        <el-input
                            style="display: inline-block"
                            data-vv-delay="1000"
                            name="selectedChildDfpNetworkCode"
                            type="text"
                            placeholder="Search Child Network Code"
                            v-model="selectedChildDfpNetworkCode"
                            @keyup.enter.native="filterHBunitBidder()"
                        ></el-input>
                    </div>
                    <div style="overflow: auto">
                        <el-checkbox
                            class="col-md-4"
                            style="
                                padding-left: 10px;
                                width: 100%;
                                padding-top: 8px;
                            "
                            v-model="searchNetworkOverride"
                            >Search Network Override?</el-checkbox
                        >
                    </div>
                    <hr />
                    <div class="row">
                        <div
                            class="col-lg-12 col-md-12 bidder-config-layout"
                            v-if="hbBidderPartnerList.length > 0"
                            v-for="hbUnit in hbBidderPartnerList"
                        >
                            <div class="col-lg-4 col-md-4">
                                {{ hbUnit.name }}
                                <div style="font-size: 12px; font-weight: 600">
                                    {{
                                        hbUnit["dfp-ad-unit-path"]
                                            ? "" + hbUnit["dfp-ad-unit-path"]
                                            : ""
                                    }}
                                </div>
                            </div>
                            <div class="col-lg-8 col-md-8">
                                <h3
                                    class="col-lg-4 col-md-4 box-title"
                                    v-for="bidders in hbUnit.bidders"
                                >
                                    <!-- <input style="margin-right: 5px;" type="checkbox" v-model="bidders.isChecked">{{bidders.bidder}}. ({{bidders.dimension}}) -->

                                    <el-checkbox v-model="bidders.isChecked">
                                        {{ bidders.bidder.name }}. ({{
                                            bidders.dimension
                                        }})
                                    </el-checkbox>
                                </h3>
                            </div>
                        </div>
                        <div
                            class="col-lg-12 col-md-12"
                            v-if="hbBidderPartnerList.length < 1"
                        >
                            <h3 class="box-title text-center">
                                No Header Bidding Ad unit present.
                            </h3>
                        </div>
                    </div>
                </div>
                <el-pagination
                    style="text-align: center; margin-top: 30px"
                    @current-change="handleCurrentChange"
                    :page-size="offset"
                    :pager-count="20"
                    layout="prev, pager, next"
                    :total="total_pages"
                    :current-page.sync="currentPage"
                >
                </el-pagination>
            </div>
            <!-- <div class="box" v-for="hbUnit in hbBidderPartnerList">
				<div class="box-header with-border">
					{{hbUnit.name}}
				</div>
				<div class="box-body">
					<div class="row">
						<div class="col-lg-2 col-md-4" v-for="bidders in hbUnit.bidders">
							<h3 class="box-title"><input style="margin-right: 5px;" type="checkbox" v-model="bidders.isChecked">{{bidders.bidder}}</h3>
						</div>
					</div>
				</div>
			</div> -->
        </section>
    </div>
</template>

<script>
import axios from "axios";

export default {
    data() {
        return {
            checkedBidderList: [],
            domainMcmEnabled: false,
            selectedChildDfpNetworkCode: "",
            selectedNetworkCode: "",
            searchNetworkOverride: "",
            searchString: "",
            total_pages: 1,
            currentPage: 1,
            offset: 20,
            bucketId: undefined,
            hbBidderPartnerList: [],
            allBidders: [],
            checkedBidders: [],
            issearch: false,
            loading: {
                bidderList: true,
                checkedBidderList: true,
                adUnitList: true
            },
            domain_details: undefined,
            pubUid: "",
        };
    },
    created: function () {
        this.getDomainDetails();
        this.getBidderList();
        this.getCheckedBidders();
        this.initialize(this.currentPage);
    },
    watch: {
        $route(to, from) {
            console.warn(`route changed from ${from} to ${to}`);
            this.allBidders = [];
            this.hbBidderPartnerList = [];
            this.checkedBidders = [];
            this.loading = true;
            this.getBidderList();
            this.getCheckedBidders();
            this.initialize(this.currentPage);
        },
    },
    methods: {
        clearSearch() {
            this.searchString = "";
            this.selectedChildDfpNetworkCode = "";
            this.selectedNetworkCode = "";
            this.searchNetworkOverride = false;
            this.initialize(1);
        },
        filterHBunitBidder() {
            this.currentPage = 1;
            this.issearch = true;
            this.initialize(1);
        },
        handleCurrentChange(val) {
            console.log("val", val);
            this.initialize(this.currentPage);
        },
        getDomainDetails() {
            this.pubUid = this.$route.params.uuid;
            axios
                .all([
                    axios.get(
                        BASE_URL +
                            `v1/publishers/${this.pubUid}/domains/${this.$route.params.domId}/`
                    ),
                ])
                .then(
                    axios.spread((domain) => {
                        this.domain_details = domain.data;
                        if (this.domain_details != undefined) {
                            this.domainMcmEnabled =
                                this.domain_details.mcm_enable;
                        }
                    })
                )
                .catch((e) => {
                    console.log(e);
                });
        },
        getCheckedBidders() {
            this.loading.checkedBidderList = true;
            axios.get(
                BASE_URL +
                `v1/update-bucket-for-all-bidders/domain/${this.$route.params.domId}/bucket/${this.$route.params.bucketId}/`
            ).then((checkedBidderList) => {
                this.checkedBidderList = checkedBidderList.data
                this.loading.checkedBidderList = false;
            })
        },
        getBidderList(){
            this.loading.bidderList = true
            axios.get(
                BASE_URL +
                "v1/get-bidders-under-domain/" +
                this.$route.params.domId
            ).then(bidderList => {
                this.allBidders = bidderList.data.sort((a, b) => {
                                        return a.code.localeCompare(b.code);
                                    });

                this.allBidders.forEach((bidder) => {
                    bidder["all"] = this.checkIfAll(bidder.id);
                });
                console.log(this.allBidders);
                this.loading.bidderList = false;
            })
        },
        initialize(pageNum) {
            this.pubUid = this.$route.params.uuid;
            if (this.searchString.length != 0) {
                this.issearch = true;
            }
            this.loading.adUnitList = true;
            if (pageNum == undefined) {
                pageNum = 1;
            }
            this.bucketId = this.$route.params.bucketId;

            var searchapi =
                BASE_URL +
                `v1/search-hb-ad-units-in-bucket/domain/${this.$route.params.domId}/bucket/${this.bucketId}/?page=${this.currentPage}&offset=${this.offset}&query=${this.searchString}&dfp_network_code=${this.selectedNetworkCode}&child_dfp_network_code=${this.selectedChildDfpNetworkCode}&network_override=${this.searchNetworkOverride}`;
            axios.post(
                this.issearch
                    ? searchapi
                    : BASE_URL +
                            `v1/get_bucket_hb_units/?page=${this.currentPage}&offset=${this.offset}`,
                { bucketId: this.bucketId }
            ).then(hbUnits => {
                this.issearch = false;
                console.log("hb", hbUnits.data.total);
                this.total_pages = hbUnits.data.total;
                this.hbBidderPartnerList = hbUnits.data.data;

                this.$forceUpdate();
                this.loading.adUnitList = false;
            })
        },
        unSelectAllBidders: function () {
            var vm = this;
            this.allBidders.forEach(function (i) {
                vm.handleSelectAll(i, false);
            });
        },
        selectAllBidders: function () {
            var vm = this;
            this.allBidders.forEach(function (i) {
                vm.handleSelectAll(i, true);
            });
        },
        updatedHBBidder: function () {
            // var allCheckedBidders = [];
            console.log("this.domid", this.domId, "buktid", this.bucketId);
            var apiIscheck =
                BASE_URL +
                `v1/update-bucket-for-all-bidders/domain/${this.$route.params.domId}/bucket/${this.bucketId}/`;
            var reqobject = { selectBidder: this.checkedBidders };

            console.log("hbBidderPartnerList", this.hbBidderPartnerList);
            axios
                .post(BASE_URL + "v1/update_bucket_hb_units/", {
                    bucketId: this.bucketId,
                    hbBidderUpdate: this.hbBidderPartnerList,
                })
                .then((response) => {
                    console.log(response.data);

                    if (response.data.status) {
                        console.log(response.data.message);
                    }
                    axios.post(apiIscheck, reqobject).then((res) => {
                        console.log("res", res);
                        this.$notify({
                            title: "Success",
                            message: "Successfully updated the tags",
                            type: "success",
                        });

                    });
                    // this.hbBidderPartnerList = response.data.data;
                })
                .catch((e) => {
                    this.errors.push(e);
                    this.$notify({
                        title: "Warning",
                        message: "Something went wrong",
                        type: "warning",
                    });
                });
        },
        checkIfAll(bidderId) {
            return this.checkedBidderList[bidderId] || false
        },
        handleSelectAll(selectedBidder, selectAll = undefined) {
            this.loading.checkedBidderList = true;
            // selectedBidder.all = !selectedBidder.all;
            let sbidder = this.allBidders.filter((bidder) => {
                return bidder.id == selectedBidder.id;
            })[0];
            if (selectAll == true) {
                sbidder.all = true;
            } else if (selectAll == false){
                sbidder.all = false;
            } else {
                sbidder.all = !sbidder.all;
            }
            this.hbBidderPartnerList.forEach((hbBidderPartner) => {
                hbBidderPartner.bidders.forEach((bidder) => {
                    if (bidder.bidder.id == selectedBidder.id)
                        bidder.isChecked = sbidder.all;
                });
            });
            var bidderChecks = this.checkedBidders.filter((k) => {
                return k.bidderId == selectedBidder.id;
            });
            if (bidderChecks.length > 0) {
                var bidderIdx = this.checkedBidders
                    .map((k) => {
                        return k.bidderId;
                    })
                    .indexOf(selectedBidder.id);
                this.checkedBidders.splice(bidderIdx, 1);
            }
            this.checkedBidders.push({
                bidderId: selectedBidder.id,
                checkOrUncheck:
                    selectedBidder.all == false ? "uncheck" : "check",
            });
            this.loading.checkedBidderList = false;
        },
        modified(val) {
            this.allBidders.forEach((bidder) => {
                bidder["all"] = this.checkIfAll(bidder.id);
                this.$forceUpdate();
            });
        },
    },
};
</script>


// WEBPACK FOOTER //
// HBBucketTags.vue?2a3c98e8